import { SuccessIcon } from '@p2p/assets/svg';
import { Button, Typography } from '@p2p/components';
import { MainContainer, PaymentId } from '@p2p/entities/payment';
import { usePaymentTemplate } from '@p2p/entities/templates';
import { useEffect } from 'react';

import styles from './TransferRequestSuccess.module.scss';
import { TransferRequestSuccessProps } from './TransferRequestSuccess.types';

export const TransferRequestSuccess = ({ order, id }: TransferRequestSuccessProps) => {
  const { setIsShowSteps } = usePaymentTemplate();
  const redirect = () => window.location.replace(order?.merchant_failed_page);

  useEffect(() => {
    setIsShowSteps(false);

    return () => {
      setIsShowSteps(true);
    };
  }, [setIsShowSteps]);

  return (
    <MainContainer maxWidth="460px" className={styles.wrapper}>
      <div className={styles.container}>
        <SuccessIcon />
        <Typography variant="h1" color="heading" className={styles.text}>
          {`Заявка на проверку платежа\n успешно создана!`}
        </Typography>
        <Typography variant="text-l-medium" color="description" className={styles.text}>
          {`Статус платежа можно уточнить через\n службу поддержки казино, указав его ID.`}
        </Typography>
        <PaymentId id={id} />
      </div>

      <Button onClick={redirect} fullWidth>
        Вернуться на сайт
      </Button>
    </MainContainer>
  );
};
